import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LandingHeader from '../../components/LandingPageComponents/LandingHeader/LandingHeader';
import LandingFooter from '../../components/LandingPageComponents/LandingFooter/LandingFooter';
import { useParams } from 'react-router-dom';
import BlogFooter from '../../components/BlogComponents/BlogFooter/BlogFooter';
import BlogTitleHeader from '../../components/BlogComponents/BlogTitleHeader/BlogTitleHeader';
import BlogPost from '../../components/BlogComponents/BlogPost/BlogPost';
import { useDispatch } from 'react-redux';
import { getBlogContentById } from '../../store/redux/slices/blogSlice';
import { CircularProgress } from '@mui/material';
import BookDemoPopup from '../LandingPage/partials/BookDemoPopup';

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  // background: radial-gradient(
  //   95.86% 126.4% at 0% 5.38%,
  //   rgba(226, 243, 187, 0.7) 0%,
  //   rgba(157, 200, 187, 0.7) 100%
  // );
  height: 100vh; /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */

  @media only screen and (max-width: 768px) {
    max-height: ${(props) => (props.menuOpen ? '100vh' : 'unset')};
  }
`;
const HeaderWrapper = styled.div`
  // position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  @media only screen and (max-width: 768px) {
    position: unset;
    display: flex;
    justify-content: center;
  }
`;
const CircularLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);

  & > div {
    position: fixed;
    top: 50%;
    left: 50%;
  }

  & svg {
    transform: scale(2);
  }
`;
const BlogPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [blogContent, setBlogContent] = useState(null);
  const getData = async () => {
    setBlogContent(null);
    const data = await dispatch(getBlogContentById({ id: id }));
    setBlogContent(data?.payload?.data);
  };
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);
  return (
    <Wrapper menuOpen={menuOpen}>
      <HeaderWrapper>
        <LandingHeader
          newTheme={true}
          bgColor={'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          setMenuOpen={(data) => {
            setMenuOpen(data);
          }}
          setPopupOpen={(data) => setIsOpen(data)}
        />
      </HeaderWrapper>
      {blogContent === null || blogContent === undefined ? (
        <CircularLoader>
          <div>
            <CircularProgress />
          </div>
        </CircularLoader>
      ) : (
        <>
          <BlogTitleHeader data={blogContent} />
          <BlogPost data={blogContent} />
          <BlogFooter />
          <BookDemoPopup
            isOpen={isOpen}
            setIsOpen={(data) => setIsOpen(data)}
          />

          <LandingFooter bgColor={'#021826'} />
        </>
      )}
    </Wrapper>
  );
};
export default BlogPage;
